<div class="add_employee_modal">
  <p-button class="close_modal" (click)="closeDialog()" role="button" tabIndex="0" icon="pi pi-times"></p-button>
  
  <div class="modal_title hd_5">
    <h2>
      <img src="{{assetsConst.addUserIcon}}" alt="icon"> 
      {{isEdit ? 'Edit Member' : 'Add New Member'}}
    </h2>
  </div>

  <form [formGroup]="memberForm" (ngSubmit)="onSubmit()">
    <div class="form_grid gap_p">
      
<div class="w_100">
  <label for="first">Full Name</label>
  <input 
    type="text"
    pInputText
    class="form_field" 
    formControlName="fullName" 
    id="first" 
    appSpaceAtFirst
    placeholder="Enter Full Name" />
</div>


      <div class="w_100">
        <label for="email">Email</label>
        <input 
          class="form_field" 
          pInputText 
          formControlName="email"
          appSpaceAtFirst
          placeholder="Enter address" />
      </div>

      <div class="w_100">
        <label for="phone">Phone (optional)</label>
        <input 
          class="form_field" 
          notchmark-phone 
          pInputText 
          inputId="on_label"
          formControlName="phone"
          placeholder="Enter Phone Number"
          (phoneChange)="phoneChange($event)"
          autocomplete="off" />
      </div>

      <div class="w_100">
        <label for="detaprtment">Department</label>
        <p-select
          [options]="documents()"
          formControlName="qualification"
          optionLabel="name"
          placeholder="Department"
          name="qualification"
          class="form_field">
        </p-select>
      </div>

      <div class="w_100">
        <label for="rol">Role</label>
        <p-select 
          [options]="role" 
          formControlName="role"
          optionLabel="name" 
          appendTo="body"
          placeholder="Select Role" 
          name="role" 
          class="form_field" />
      </div>
    </div>

    <div class="btn_flex mt_20">
      <p-button 
        label="Send Invite" 
        class="w_100" 
        type="submit"
        role="button"
        tabIndex="2">
      </p-button>
    </div>
  </form>
</div>
